/* ==========================================================================
   Card Modal - Asian American Forward Website
   ========================================================================== */

export function initializeCardModal() {
  console.log('🖼️ Initializing card modal...');
  
  const modal = document.getElementById('card-modal');
  if (!modal) {
    console.warn('Card modal element not found');
    return;
  }
  
  // Modal is managed by hero-cards.js
  // This initialization ensures modal is ready
  modal.style.display = 'none';
  modal.setAttribute('aria-hidden', 'true');
  
  console.log('✅ Card modal initialized');
} 